// Dependencies
import React, { useState } from "react";
import moment from "moment";
import { Box, Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Button, DatePicker as RCDatePicker } from "@gpstrackit/gtc-react-controls";
import { Slider as MuiSlider } from "@mui/material";
import { useIntl } from "react-intl";
import { NotificationManager } from "Components/Notifications";
import { useCreateClipRequest } from "Modules/video/.globals/api/clipRequests";

export const RequestClipLightMetrics = ({ deviceId, type, onError }) => {
  const [selectedDate, setSelectedDate] = useState(moment().startOf("day"));
  const [selectedTime, setSelectedTime] = useState(moment().format("HH:mm"));
  const [durationLM, setDurationLM] = useState(60);
  const { messages } = useIntl();
  const { mutate: createClipRequest } = useCreateClipRequest({
    onSuccess: () =>
      NotificationManager.success(messages["infoBubble_clipRequestSuccess"], messages["success"], 3000, null, null, "success"),
    onError: (error) => {
      NotificationManager.warning(messages["videoMainView_errorRequestClipLM"], messages["videoClipRequest_Alert"], 3000, null, null, "info");
      onError?.(error);
    },
  });

  const [hours, minutes] = selectedTime.split(":").map(Number);
  const anchor = moment(selectedDate).startOf("day").set({ hours, minutes });
  const isToday = moment(selectedDate).isSame(moment(), "day");

  const onSubmitLM = () => {
    const dataRange = {
      start: moment(anchor).subtract(durationLM, "seconds").toDate(),
      end: moment(anchor).add(durationLM, "seconds").toDate(),
    }

    createClipRequest({ dateRange: dataRange, deviceId, type });
  };

  return (
    <>
      <Box
        style={{
          width: "100%",
          padding: "10px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Grid
          style={{ width: "100%", marginTop: 6, position: "relative" }}
          className="form-item"
        >
          <label className="input-normal-label">
            {messages["videoClipRequest_date"]}
          </label>
          <RCDatePicker
            value={selectedDate}
            maxDate={moment()}
            minDate={moment().subtract(6, "months")}
            calendarPosition="bottom"
            onChange={(newDate) => {
              setSelectedDate(moment(newDate).startOf("day"));
            }}
          />
        </Grid>
        <Grid
          style={{ width: "100%", marginTop: 16, position: "relative" }}
          className="form-item"
        >
          <label className="input-normal-label">
            {messages["videoClipRequest_time"]}
          </label>
          <input
            type="time"
            value={selectedTime}
            max={isToday ? moment().format("HH:mm") : undefined}
            onChange={(e) => setSelectedTime(e.target.value)}
            style={{
              padding: "8px",
              fontSize: 14,
              borderRadius: 4,
              border: "1px solid #ccc",
              width: "150px",
            }}
          />
        </Grid>
        <Grid
          style={{ width: "100%", marginTop: 16, position: "relative" }}
          className="form-item"
        >
          <label className="input-normal-label">
            {messages["videoClipRequest_selectRangeDate"]}
          </label>
          <Box px={2}>
            <MuiSlider
              max={90}
              min={0}
              value={durationLM}
              getAriaValueText={() => {
                return `${moment(anchor)
                  .add(durationLM, "seconds")
                  .format("hh:mm:ss a")}`;
              }}
              step={1}
              onChange={(_, newValue) => {
                setDurationLM(newValue < 60 ? 60 : newValue);
              }}
            />
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography>
                {moment(anchor).subtract(durationLM, "seconds").format("hh:mm:ss a")}
              </Typography>
              <Typography>
                {moment(anchor).add(durationLM, "seconds").format("hh:mm:ss a")}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Box mt='90px' display='flex' justifyContent='end'>
            <Button onClick={onSubmitLM}>{messages["accountContacts_add"]}</Button>
        </Box>
      </Box>
    </>
  );
};
